import { Typography } from "@suraasa/placebo-ui"
import { FaceDetectionImage } from "features/Cpat/Assessments/Instructions/ProctoringDuringAssessment"

import { NeedHelp } from "./NeedHelp"

export const FaceDetectionView = () => {
  return (
    <div>
      <div className="mb-2 flex items-center gap-3">
        <div className="hidden size-6 items-center justify-center rounded-full bg-surface-200 text-black-600 lg:flex">
          <div className="size-3 rounded-full bg-current" />
        </div>
        <Typography variant="title3" className="text-onSurface-900">
          Face Detection
        </Typography>
      </div>

      <div>
        <Typography className="mb-2">
          To maintain the integrity of the assessment and ensure fairness, the
          assessment uses face detection technology. This will help verify your
          identity and monitor your environment.
        </Typography>
        <Typography className="mb-2">
          Please ensure the following before getting started with the
          assessment:
        </Typography>

        <ul
          style={{
            listStyleType: "disc",
            listStylePosition: "inside",
          }}
        >
          <li>
            Sit in a well-lit area where your face is clearly visible at all
            times.
          </li>
          <li>
            Choose a location with a simple, static background, without any
            people or excessive movement.
          </li>
          <li>Avoid covering your face with masks, hats, or other items.</li>
        </ul>

        <div className="mt-4 grid grid-cols-2 gap-5">
          <div className="col-span-2 md:col-span-1">
            <FaceDetectionImage type="good" />
          </div>
          <div className="col-span-2 md:col-span-1">
            <FaceDetectionImage type="bad" />
          </div>
        </div>

        <NeedHelp />
      </div>
    </div>
  )
}
